/**
 * Created by calhosh on 9/27/2017.
 */
import * as types from './actiontypes';
import {emitErrorMessageEvent, emitInfoMessageEvent, emitSuccessMessageEvent, emitWarningMessageEvent} from '../util/messageHubUtils';

/**
 * Clear all messages in the store.
 * @returns {Object} Clear Errors action.
 */
export function clearErrors() {
	return {type: types.CLEAR_ERRORS};
}

/**
 * Raise an error from JavaScript code. This is for validation failure
 * @param {Function} emit - The emit function from useMessageHubEmit
 * @param {String} message - User-facing error message text to display
 * @param {boolean} isMFE - Flag indicating if the application is running as a Micro Frontend
 * @param {boolean} isModalOpen - Flag indicating if a modal is currently open
 * @return {Object|undefined} validation error or undefined if emitted
 */
export function raiseJSValidationError(emit, message, isMFE = false, isModalOpen = false) {
	// Only emit to message hub when in MFE mode (embedded in parent application)
	if (isMFE && emit && !isModalOpen) {
		emitErrorMessageEvent(emit, {message: message});
	}
	return {type: types.CLIENT_VALIDATION_ERROR, message: message};
}

/**
 * Raise a SUCCESS from JavaScript code. This is for displaying success message
 * @param {Function} emit - The emit function from useMessageHubEmit
 * @param {String} message - entities hierarchy
 * @param {number} autoDismissInSeconds - Time in seconds before the message auto-dismisses (0 = no auto-dismiss)
 * @param {boolean} isMFE - Flag indicating if the application is running as a Micro Frontend
 * @param {boolean} isModalOpen - Flag indicating if a modal is currently open
 * @return {Object} success message action
 */
export function raiseSuccessMessage(emit, message, autoDismissInSeconds = 0, isMFE = false, isModalOpen = false) {
	// Only emit to message hub when in MFE mode and no modal is open
	if (isMFE && emit && !isModalOpen) {
		emitSuccessMessageEvent(emit, message, autoDismissInSeconds);
	}
	return {type: types.SUCCESS_MESSAGE, message: message, autoDismissInSeconds};
}

/**
 * Raise a WARNING from JavaScript code. This is for displaying warning message
 * @param {Function} emit - The emit function from useMessageHubEmit
 * @param {String} message - entities hierarchy
 * @param {number} autoDismissInSeconds - Time in seconds before the message auto-dismisses (0 = no auto-dismiss)
 * @param {boolean} isMFE - Flag indicating if the application is running as a Micro Frontend
 * @return {Object|undefined} warning message or undefined if emitted
 */
export function raiseWarningMessage(emit, message, autoDismissInSeconds = 0, isMFE = false) {
	// Only emit to message hub when in MFE mode (embedded in parent application)
	if (isMFE && emit) {
		emitWarningMessageEvent(emit, message, autoDismissInSeconds);
	}
	return {type: types.WARNING_MESSAGE, message: message, autoDismissInSeconds};
}

/**
 * Raise an INFORMATION from JavaScript code. This is for displaying information message
 * @param {Function} emit - The emit function from useMessageHubEmit
 * @param {String} message - entities hierarchy
 * @param {number} autoDismissInSeconds - Time in seconds before the message auto-dismisses (0 = no auto-dismiss)
 * @param {boolean} isMFE - Flag indicating if the application is running as a Micro Frontend
 * @return {Object|undefined} information message or undefined if emitted
 */
export function raiseInformationMessage(emit, message, autoDismissInSeconds = 0, isMFE = false) {
	// Only emit to message hub when in MFE mode (embedded in parent application)
	if (isMFE && emit) {
		emitInfoMessageEvent(emit, message, autoDismissInSeconds);
	}
	return {type: types.INFO_MESSAGE, message: message, autoDismissInSeconds};
}

export function raiseDochelperError(error) {
	return {type: types.DOCHELPER_ERROR, error: error};
}

export function raiseInvalidRelatedEntityError(error) {
	return {type: types.INVALID_RELATED_ENTITY, error: error};
}
